import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';
import { LocalService } from '../../../services/ local.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  name: String = '';
  rememberMe: Boolean;
  submitted = false;
  public form: FormGroup;
  error: string;
  public id;
  loading = false;
  public isChecked: any;
  errorMessage;
  passType: any;
  isShowPassword:boolean;
  constructor(
    private localStore: LocalService,
    public router: Router,
    private authenticationService: AuthservicesService,
    private authservice: AuthservicesService,
    public fb: FormBuilder
  ) {
    this.errorMessage = environment.errorMessage;
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      rememberMe: [null],
    });
  }

  ngOnInit(): void {
    const email = this.localStore.getData('ministryEmail');
    const password = this.localStore.getData('ministryPassword');
    this.rememberMe =   !!this.localStore.getData('ministryEmail') && !!this.localStore.getData('ministryPassword');
    this.form.patchValue({
      email: email || '',
      password: password || '',
    });
  }

  get f() {
    return this.form.controls;
  }

  isPasswordShow() {
    this.isShowPassword = !this.isShowPassword;
  }
  checkCheckBoxvalue(event) {
    this.isChecked = event.target.checked;
    if (this.isChecked) {
      localStorage.setItem('checked', 'true');
    } else {
      localStorage.removeItem('checked');
    }
  }

  goToSignup(){
    this.router.navigate(['/sign-up'])
  }

  socialLogin(obj) {
    localStorage.removeItem('ministry_currentUser');
    this.authenticationService.loginWithSocailMedia(obj).subscribe(
      (data) => {
        console.log(data, 'data');
        let user = JSON.parse(localStorage.getItem('ministry_currentUser'));
        if (user.isEmailVarified == true && user.isFirstUpdateDone == true) {
          this.router.navigate(['/profile-management']);
          this.authenticationService.successMessage(
            environment.loginSuccessfullyMessage,
            'success'
          );
        } else if (
          user.isFirstUpdateDone == false &&
          user.isEmailVarified == false
        ) {
          this.router.navigate(['/user-registration/basic-info']);
          this.authenticationService.successMessage(
            environment.resgisterationCompleteMessage,
            'success'
          );
        } else if (
          user.isFirstUpdateDone == true &&
          user.isEmailVarified == false
        ) {
          this.router.navigate(['/email-verification']);
          this.authenticationService.successMessage(
            environment.verifyEmail,
            'success'
          );
        }
      },
      (error) => {
        localStorage.removeItem('user');
        if (error) {
          this.authenticationService.successMessage(
            error.error.message,
            'error'
          );
        }
      }
    );
  }
  checkTermsAndConditions() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover your account!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
      }
    });
  }

  public googleLogin() {
    this.isChecked = localStorage.getItem('checked');
    // if (!this.isChecked) {
    //   this.authenticationService.successMessage(environment.checkboxMessage, 'error');

    //   return
    // }
    localStorage.removeItem('ministry_token');
    localStorage.removeItem('ministry_currentUser');
    this.authenticationService.doGoogleLogin().then(
      (data) => {
        console.log('authentication service data', data);
        this.authenticationService.GetToken().then(
          (userToken) => {
            let info = {
              email: data.additionalUserInfo.profile.email,
              name: data.additionalUserInfo.profile.name,
            };
            localStorage.setItem('user', JSON.stringify(info));
            let obj = {
              deviceType: 'web',
              deviceId: '1',
              version: '1.0',
              role: 'Community',
              socialType: 'google',
              token: userToken,
            };
            this.socialLogin(obj);
          },
          (error) => {
            if (error) {
              this.authenticationService.successMessage(
                error.error.message,
                'error'
              );
            }
          }
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public facebookLogin() {
    this.isChecked = localStorage.getItem('checked');
    // if (!this.isChecked) {
    //   this.authenticationService.successMessage(environment.checkboxMessage, 'error');

    //   return
    // }
    this.authenticationService.doFacebookLogin().then(
      (data) => {
        console.log(data, 'data');
        this.authenticationService.GetToken().then(
          (userToken) => {
            let info = {
              email: data.additionalUserInfo.profile.email,
              name: data.additionalUserInfo.profile.name,
            };
            localStorage.setItem('user', JSON.stringify(info));
            let obj = {
              deviceType: 'web',
              deviceId: '1',
              version: '1.0',
              role: 'Community',
              socialType: 'facebook',
              token: userToken,
            };
            this.socialLogin(obj);
          },
          (error) => {
            if (error) {
              this.authenticationService.successMessage(
                error.error.message,
                'error'
              );
            }
          }
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  redirect() {
    let isChecked = localStorage.getItem('checked');
    if (isChecked) {
      this.router.navigate(['/sign-in']);
    } else {
      this.authenticationService.successMessage(
        environment.checkboxMessage,
        'error'
      );
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if (this.form.valid) {
      let email = this.form.get('email').value;
      let password = this.form.get('password').value;
      let deviceType = 'web';
      let version = '1';
      let role = 'Community';
      let obj = {
        email: email,
        password: password,
        deviceType: deviceType,
        version: version,
        role: role,
      };
      this.authservice.login(obj).subscribe(
        (data) => { 
          if (this.rememberMe) {
            this.localStore.saveData('ministryEmail', this.form.value.email);
            this.localStore.saveData('ministryPassword', this.form.value.password);
            localStorage.setItem('rememberMe', this.form.value.rememberMe);
          } else {
            this.localStore.removeData('ministryEmail');
            this.localStore.removeData('ministryPassword');
            this.localStore.removeData('rememberMe');
          }

          localStorage.setItem('ministry_id', data._id);
          this.id = data._id;
          let user = JSON.parse(localStorage.getItem('ministry_currentUser'));
          let completeReg = JSON.parse(localStorage.getItem('completeReg'));
          if (user.isEmailVarified == true && user.isFirstUpdateDone == true) {
            this.router.navigate(['/profile-management']);
            this.authservice.successMessage(
              environment.loginSuccessfullyMessage,
              'success'
            );
          } else if (
            user.isEmailVarified == true &&
            user.isFirstUpdateDone == false
          ) {
            let info = { email: email, name: '' };
            localStorage.setItem('user', JSON.stringify(info));
            this.router.navigate(['/user-registration/basic-info']);
            this.authservice.successMessage(
              environment.resgisterationCompleteMessage,
              'success'
            );
          } else if (
            user.isEmailVarified == false &&
            user.isFirstUpdateDone == false
          ) {
            let info = { email: email, name: '' };
            localStorage.setItem('userobj', JSON.stringify(user));
            // localStorage.setItem('user', JSON.stringify(info));
            this.router.navigate(['/email-verification']);
            this.authservice.successMessage(environment.verifyEmail, 'success');
          }
        },
        (error) => {
          if (error.status == 401) {
            localStorage.removeItem('ministry_currentUser');
          } else {
            this.authservice.successMessage(error.error.message, 'error');
          }
        }
      );
    }
  }

  openSignUpPage(){
    this.router.navigate(['/sign-up']);
  }
}
